module.exports = __webpack_public_path__ + "static/media/stat-1.b0fd0942.svg";